export default "__VITE_ASSET__BkGTvRSS__"